import { Component, signal } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DataService } from '../../services/data.service';

interface MasterRecord {
  id: number;
  md_code: string;
  md_name: string;
  description: string;
  sort_ord: number;
  is_active: boolean;
	data_for: string;
}
interface MasterTypes {
	code: string,
	name: string,
	title: string
}

@Component({
  selector: "app-master-data",
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: "./master-data.component.html",
  styleUrls: ["./master-data.component.scss"],
})
export class MasterDataComponent {
  base = 'mdata';		// important for API calls
  loading = false;
  user: any = null;

  frmData: MasterRecord = this.emptyRecord();
  records: MasterRecord[] = [];
	allData: any = [];
	tblData = signal({"code": "", "name": "", "title": ""});
  editing = false;
  searchText = "";
  currentPage = 1;
  pageSize = 10;
  sortColumn = "id";
  sortDirection = true;
	mdata4load: any = [];

  constructor(public dataService: DataService) {
		//
  }

	// ngOnChanges() {
	async ngOnInit() {
		let erp_rem: any = localStorage.getItem("erp_rem");
		if(erp_rem) {
			erp_rem = JSON.parse(erp_rem);
			erp_rem = this.dataService.deCodeUser(erp_rem);
			this.user = erp_rem;
    }

    this.loading = true;
    await this.dataService.getAllRecords(this.base).then((res: any) => {
      this.allData = res;
      this.dataService.getDDData();
      this.loading = false;
    });

		this.mdata4load = this.dataService.mdata4load;
		// if(this.mdata4load) {
		// 	let self: any = this;

		// 	if(!self.tblData().name) {
    //     setTimeout(()=>{
    //       self.setMaster(self.mdata4load[0]);
    //     }, 500);
    //   }
		// }
	}

  emptyRecord(): MasterRecord {
    return {
      id: 0,
      md_code: "",
      md_name: "",
      description: "",
      sort_ord: 1,
      is_active: true,
			data_for: ""
    };
  }

  save() {
    if (this.frmData.md_code.trim() == "" || this.frmData.md_name.trim() == "") {
      alert("Please fill mandatory fields.");
      return;
    }

    if(this.frmData.data_for=='') {
      this.frmData.data_for = this.tblData().name;
    }

    if (this.editing) {
      const index = this.records.findIndex((x) => x.id == this.frmData.id);
      this.records[index] = { ...this.frmData };
			this.doUpdate();
    } else {
      this.frmData.id = this.getNextId();
      this.records.unshift({ ...this.frmData });
			this.doSave();
    }

    this.reset();
  }

  edit(item: MasterRecord) {
    this.frmData = { ...item };
    this.editing = true;
  }

  delete(id: number) {
    // if (confirm("Delete this record?")) {
      this.records = this.records.filter((x) => x.id != id);
    // }
  }

  reset() {
    this.frmData = this.emptyRecord();
    this.editing = false;
  }

  getNextId(): number {
    return this.records.length
      ? Math.max(...this.records.map((x) => x.id)) + 1
      : 1;
  }

  get filteredData() {
    let data = this.records.filter(
      (x) =>
        x.md_code.toLowerCase().includes(this.searchText.toLowerCase()) ||
        x.md_name.toLowerCase().includes(this.searchText.toLowerCase()) ||
        x.description.toLowerCase().includes(this.searchText.toLowerCase())
    );

    data.sort((a: any, b: any) => {
      if (a[this.sortColumn] > b[this.sortColumn])
        return this.sortDirection ? 1 : -1;

      if (a[this.sortColumn] < b[this.sortColumn])
        return this.sortDirection ? -1 : 1;

      return 0;
    });

    return data;
  }

  get pagedData() {
    const start = (this.currentPage - 1) * this.pageSize;
    return this.filteredData.slice(start, start + this.pageSize);
  }

  totalPages() {
    return Math.ceil(this.filteredData.length / this.pageSize);
  }

  changePage(page: number) {
    if (page >= 1 && page <= this.totalPages()) this.currentPage = page;
  }

  sort(column: string) {
    if (this.sortColumn == column) {
      this.sortDirection = !this.sortDirection;
    } else {
      this.sortColumn = column;
      this.sortDirection = true;
    }
  }

	setMaster(md: any) {

    this.frmData.data_for = md.name;
		this.tblData.set(md);
		this.records = this.allData.filter((obj: any)=>{
			return obj.data_for == md.name;
		});
	}

  doSave() {
    this.loading = true;
		this.frmData.data_for = this.tblData().name;

    this.dataService.addNewRecord(this.base, this.frmData).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        this.loading = false;
        // this.emptyRecord();
        this.ngOnInit();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }

  doUpdate() {
    this.loading = true;
		const myid = this.frmData.id;
		this.frmData.id = 0;
		this.frmData.data_for = this.tblData().name;

    this.dataService.updateRecord(this.base, myid, this.frmData).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        this.loading = false;
        // this.emptyRecord();
        this.ngOnInit();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
  }

	async deleteClick(myid: number) {
    const confirmed = await this.dataService.confirmDelete();
    if (confirmed) {
        console.log('Item deleted successfully');
				this.doDelete(myid);
    } else {
        console.log('Deletion cancelled');
    }
	}

  doDelete(myid: number) {
		this.loading = true;
    this.dataService.deleteRecord(this.base, myid).subscribe({
      next: (response) => {
        // console.log('Response received in component:', response);
        this.delete(myid);
				this.loading = false;
        this.ngOnInit();
      },
      error: (error) => {
        console.error('Error received in component:', error);
        this.loading = false;
      }
    });
	}

}
